// get path for webapp light
export default function getPathLight(relativePath, whiteLabel, language) {
  if (whiteLabel.path) {
    return "/" + whiteLabel.path + relativePath;
  } else {
    return relativePath;
  }
}
